import { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import HRTraining from './Products';
import { TabGroup } from './Products';
import CaseItem from "./CaseItem";
import { useLocation } from 'react-router-dom';
import ImgModal from './ImgModal';

const Index = () => {
    const location = useLocation();
    const [value, setValue] = useState(location.state ? location.state.tabVal : 'Hr');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <>
            <FormControl component="article" fullWidth>
                <Grid container>
                    <Grid item style={{ marginLeft: "auto", marginRight: "auto" }} xs={12} md={10} xl={9}>
                        {
                            TabGroup.map((group) => {
                                return (
                                    <Grid>
                                        <h2 className="main-header">{group.label}</h2>
                                        {
                                            HRTraining.filter(el => el.tabGroup.findIndex(x => x == group.value) != -1).map(function (el, index) {
                                                return (<CaseItem caseEl={el} key={index} />)
                                            })
                                        }
                                    </Grid>
                                );
                            })
                        }
                    </Grid>
                </Grid>
            </FormControl>
            <ImgModal />
        </>

    );
}


export default Index;